const userReducer = (state, action) => {
    switch(action.type){
        case "LOGIN": 
            return {
                ...state,
                logged: true,
            }
        case "LOGOUT":
            localStorage.removeItem("user");
            return {
                logged: false
            }
        default: 
            return state;
    }
}

export default userReducer;